module.exports = __webpack_public_path__ + "static/WebApp-3.3a8c0a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/web-app/assets/WebApp-3.png
// module id = 281
// module chunks = 35783957827783